import GhostContentAPI from '@tryghost/content-api';

export default GhostContentAPI({
  url: 'https://www.lbstudio.sk/cms',
  key: 'f3bbc3786e92165f386ff23f56',
  version: 'v2',
});

// https://gist.github.com/ErisDS/f516a859355d515aa6ad
// https://ghost.org/docs/api/v2/javascript/content/



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/API/index.js